import { createContext, useCallback, useContext, useState } from 'react';

const AlertContext = createContext();

const AlertProvider = ({ children }) => {
  const [state, setState] = useState(null);
  const setAlert = useCallback(alert => setState(alert), []);
  const updateAlertBody = useCallback(
    body => setState(state => ({ ...state, body })),
    []
  );

  return (
    <AlertContext.Provider value={{ alert: state, setAlert, updateAlertBody }}>
      {children}
    </AlertContext.Provider>
  );
};

const useAlert = () => useContext(AlertContext);

export { AlertProvider, useAlert };
